const MuiPaper = {
  defaultProps: {
    elevation: 1
  }
};
export default MuiPaper;